import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { LeadDto } from '@model/LeadDto'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { LeftSection } from '../../Components/LeftSection'
import { SignupFormWrapper } from '../../Components/SignupFormWrapper'
import { SignupSections, SignupStep } from '../../Components/SignupStep'
import { SignupWrapper } from '../../Components/SignupWrapper'

import styles from './CompanyDetailsTemplate.module.scss'

export interface CompanyDetailsTemplateProps {
  lead?: LeadDto
  step: number

  goBack?: () => void
  reversed?: boolean
  totalSteps: number
}

export const CompanyDetailsTemplate: React.FC<PropsWithChildren<CompanyDetailsTemplateProps>> = (
  props
) => {
  const { lead, step, children, totalSteps, goBack, reversed } = props
  useScrollToTop({ effect: [step] })

  const { t } = useTranslation()

  return (
    <SignupFormWrapper label={t('Sign up.Sign up')} onBackToPreviousStep={goBack}>
      <SignupStep
        subStep={{
          current: step,
          total: totalSteps,
        }}
        section={SignupSections.CompanyDetails}
        accountTypeId={lead?.type?.id}
      />
      <SignupWrapper>
        <React.Fragment>
          <LeftSection
            title={t('Sign up.Company Details')}
            description={() => (
              <div>
                {lead?.tickmillCompany.id === TickmillCompaniesEnum.TICKMILL_UK ? (
                  <Body1 isParagraph>
                    {t(
                      "Sign up.Next up, we'd like to know a little bit more about your company UK"
                    )}
                  </Body1>
                ) : (
                  <Body1 isParagraph>
                    {t("Sign up.Next up, we'd like to know a little bit more about your company")}
                  </Body1>
                )}
                <br />
                <Body1 isParagraph>
                  {t('Sign up.Be prepared by having your company documents next to you')}
                </Body1>
                <br />
              </div>
            )}
          />
          <section
            className={classNames(styles.formSection, {
              [styles.reversed]: reversed,
            })}
          >
            {children}
          </section>
        </React.Fragment>
      </SignupWrapper>
    </SignupFormWrapper>
  )
}
